import { Controller } from '@hotwired/stimulus';
import Leaflet from 'leaflet';
import markerUrl from '../../images/leaflet-marker.svg';

export default class extends Controller {

    connect() {

        this.leafletMarkers = [];
        const context = this;
        const element = this.element;

        const mapElm = element.querySelector(".map");
        if ( !mapElm.hasAttribute("data-markers") ) return;

        const markers = JSON.parse(mapElm.getAttribute("data-markers"));
        if (markers.length < 1) return;

        const center = [markers[0]['lat'], markers[0]['lng']];
        const zoom = 16;
        const map = Leaflet.map(mapElm, {
            center: center,
            zoom: zoom,
            zoomSnap: false,
            scrollWheelZoom: false,
        })

        Leaflet.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}', {
            attribution: '',
            id: 'demovilius/clbq91853002x14qrzxd8ac2d',
            tileSize: 512,
            zoomOffset: -1,
            accessToken: 'pk.eyJ1IjoiZGVtb3ZpbGl1cyIsImEiOiJjam5zeTJsaWswM2UxM3JvMXppamxkeXl2In0.gSBxj7rBcrJANrH_IzleiA',
        }).addTo(map)

        context.markerIcon = Leaflet.icon({
            iconUrl: markerUrl,
            iconSize: [32, 40],
            iconAnchor: [16, 40],
            popupAnchor: [0, 0],
        });

        markers.forEach(function(marker) {

            const leafletMarker = Leaflet
                .marker([marker['lat'], marker['lng']], { icon: context.markerIcon })
                .addTo(map)

            context.leafletMarkers.push(leafletMarker);
        })

        // try to fit markers in map view
        const bounds = new Leaflet.featureGroup(this.leafletMarkers).getBounds();
        //map.fitBounds(bounds, { padding: [10, 10] });

        window.addEventListener('resize', () => {
            setTimeout(function () {
                //map.fitBounds(bounds, { padding: [10, 10] });
            }, 100)
        });
    }
}